var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailsInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 95,
    viewBox: "0 0 68 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7105 90.4482C67.7105 92.9272 65.7041 94.942 63.225 94.942L5.22014 95.0083C3.24684 95.0083 1.57203 93.7398 0.966778 91.9737C0.809246 91.5177 0.726334 91.0368 0.726334 90.5311L0.635132 6.88167C0.635132 4.40261 2.64159 2.38786 5.12064 2.38786L58.383 2.32982L63.1255 2.32153C65.6046 2.32153 67.6193 4.32799 67.6193 6.80704L67.7105 90.4482Z",
    fill: "url(#paint0_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6995 89.9673L6.73743 90.0254C5.40255 90.0254 4.3247 88.9475 4.3247 87.6126L4.24179 9.76703C4.24179 8.43215 5.31964 7.3543 6.65452 7.3543L61.6083 7.29626C62.9431 7.29626 64.021 8.37411 64.021 9.70899L64.1039 87.5546C64.1122 88.8812 63.0343 89.9673 61.6995 89.9673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9804 13.7136L13.8927 13.7633C12.5661 13.7633 11.4799 12.6855 11.4799 11.3589L11.4716 4.67623C11.4716 3.34964 12.5495 2.2635 13.8761 2.2635L53.9721 2.22205C55.2987 2.22205 56.3848 3.2999 56.3848 4.62648L56.3931 11.3091C56.3848 12.6357 55.307 13.7136 53.9804 13.7136ZM13.8761 3.49059C13.2294 3.49059 12.6987 4.02123 12.6987 4.66793L12.707 11.3506C12.707 11.9973 13.2377 12.5279 13.8844 12.5279L53.9804 12.4865C54.6271 12.4865 55.1577 11.9559 55.1577 11.3091L55.1494 4.62648C55.1494 3.97977 54.6188 3.44914 53.9721 3.44914L13.8761 3.49059Z",
    fill: "url(#paint1_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8445 5.11564L15.41 5.1571C14.9954 5.1571 14.6638 4.82545 14.6638 4.41089V0.787659C14.6638 0.373102 14.9954 0.0414557 15.41 0.0414557L52.8362 0C53.2508 0 53.5824 0.331646 53.5824 0.746203V4.36944C53.5907 4.78399 53.2591 5.11564 52.8445 5.11564Z",
    fill: "url(#paint2_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4431 5.15714L52.8113 5.11568C53.2425 5.11568 53.5907 4.76746 53.5907 4.33632V2.56201L14.6555 2.60347V4.37777C14.6555 4.80891 15.012 5.15714 15.4431 5.15714Z",
    fill: "#58D6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5763 81.2118L25.3428 61.6447L22.7228 70.1597L15.2276 70.168C14.7715 70.168 14.4067 69.8031 14.4067 69.3471C14.4067 68.8911 14.7715 68.5263 15.2276 68.5263L21.5205 68.518L25.8402 54.4977L29.0738 74.1145L33.2691 60.6414L35.4994 67.0256L40.5239 54.8459L45.4074 74.1643L47.248 68.0205L52.6372 68.0123C53.0932 68.0123 53.4581 68.3771 53.4581 68.8331C53.4581 69.2891 53.0932 69.6539 52.6372 69.6539L48.4668 69.6622L45.2747 80.3163L40.1508 60.0528L35.3668 71.6355L33.352 65.8731L28.5763 81.2118Z",
    fill: "#58D6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0212 43.4871L12.4831 43.4954C10.7835 43.4954 9.39054 42.1107 9.39054 40.411L9.37396 25.6777C9.37396 23.978 10.7586 22.5851 12.4583 22.5851L22.9963 22.5768C24.696 22.5768 26.0889 23.9614 26.0889 25.6611L26.1055 40.3945C26.1055 42.0942 24.7209 43.4788 23.0212 43.4871ZM12.45 23.4805C11.2395 23.4805 10.2611 24.4672 10.2611 25.6777L10.2777 40.411C10.2777 41.6216 11.2643 42.5999 12.4749 42.5999L23.0129 42.5916C24.2234 42.5916 25.2018 41.605 25.2018 40.3945L25.1852 25.6611C25.1852 24.4506 24.1985 23.4722 22.988 23.4722L12.45 23.4805Z",
    fill: "url(#paint3_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7398 40.6598C22.7228 40.6515 24.2732 37.7745 24.2732 37.7745C24.0493 37.4926 23.7674 37.2439 23.386 36.9951C22.076 36.1411 21.0231 35.7763 20.5836 35.4115C20.1359 35.055 19.8872 34.5327 19.8872 34.5327L19.6136 34.6985C19.6136 34.6985 19.4477 34.1264 19.539 33.2558C19.539 33.2558 19.9286 33.1563 20.2188 31.838C20.6831 31.9292 21.2303 30.7519 20.9733 30.3207C20.8075 30.0388 20.6085 30.0637 20.4676 30.1301C20.6085 29.5414 21.2469 26.283 17.7315 26.283C14.216 26.283 14.8544 29.5414 15.0037 30.1301C14.8627 30.0637 14.6638 30.0388 14.4979 30.3207C14.2409 30.7519 14.7964 31.9292 15.2607 31.838C15.5509 33.1563 15.9489 33.2475 15.9489 33.2475C16.0484 34.1098 15.8743 34.6902 15.8743 34.6902L15.6007 34.5244C15.6007 34.5244 15.3519 35.0384 14.9042 35.4032C14.4565 35.768 13.4118 36.1411 12.1018 36.9951C11.7204 37.2439 11.4302 37.4926 11.2146 37.7745C11.2063 37.7911 12.7651 40.6681 17.7398 40.6598Z",
    fill: "url(#paint4_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5561 27.2779L30.2677 27.3028C29.8863 27.3028 29.5795 26.996 29.5795 26.6146V26.4986C29.5795 26.1172 29.8863 25.8104 30.2677 25.8104L50.5561 25.7855C50.9375 25.7855 51.2443 26.0923 51.2443 26.4737V26.5898C51.2443 26.9712 50.9292 27.2779 50.5561 27.2779Z",
    fill: "url(#paint5_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0941 31.1416L30.2677 31.1582C29.8863 31.1582 29.5795 30.8514 29.5795 30.47V30.3539C29.5795 29.9725 29.8863 29.6658 30.2677 29.6658L43.0941 29.6492C43.4755 29.6492 43.7823 29.9559 43.7823 30.3373V30.4534C43.7823 30.8348 43.4755 31.1416 43.0941 31.1416Z",
    fill: "url(#paint6_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M57.5539 35.7348L30.276 35.768C29.8946 35.768 29.5878 35.4612 29.5878 35.0798V34.9638C29.5878 34.5824 29.8946 34.2756 30.276 34.2756L57.5539 34.2424C57.9353 34.2424 58.242 34.5492 58.242 34.9306V35.0467C58.2338 35.4281 57.927 35.7348 57.5539 35.7348Z",
    fill: "url(#paint7_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.9652 48.6441L11.4634 48.6939C11.0737 48.6939 10.7503 48.3788 10.7503 47.9808V47.9145C10.7503 47.5248 11.0654 47.2015 11.4634 47.2015L56.9652 47.1517C57.3549 47.1517 57.6782 47.4668 57.6782 47.8648V47.9311C57.6782 48.3291 57.3549 48.6441 56.9652 48.6441Z",
    fill: "url(#paint8_linear_33_43)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M57.5539 40.2452L30.276 40.2784C29.8946 40.2784 29.5878 39.9716 29.5878 39.5902V39.4741C29.5878 39.0927 29.8946 38.786 30.276 38.786L57.5539 38.7528C57.9353 38.7528 58.242 39.0596 58.242 39.441V39.5571C58.242 39.9384 57.9353 40.2452 57.5539 40.2452Z",
    fill: "url(#paint9_linear_33_43)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_43",
    x1: -8.65355,
    y1: 34.748,
    x2: 76.9992,
    y2: 62.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1713,
    stopColor: "#5EABFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4084,
    stopColor: "#509AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    stopColor: "#4890FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_43",
    x1: -4.58987,
    y1: -21.375,
    x2: 56.3866,
    y2: 7.98973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_43",
    x1: 14.6543,
    y1: 2.57952,
    x2: 53.5901,
    y2: 2.57952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_43",
    x1: 14.7701,
    y1: 29.2075,
    x2: 24.5507,
    y2: 41.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33_43",
    x1: 13.7093,
    y1: 30.0293,
    x2: 23.4899,
    y2: 42.6553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0994384,
    stopColor: "#A1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#88E7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#77E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    stopColor: "#6CDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33_43",
    x1: 29.5807,
    y1: 26.551,
    x2: 51.24,
    y2: 26.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_33_43",
    x1: 29.5847,
    y1: 30.4037,
    x2: 43.7814,
    y2: 30.4037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_33_43",
    x1: 29.5894,
    y1: 35.0098,
    x2: 58.2374,
    y2: 35.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_33_43",
    x1: 10.7499,
    y1: 47.9272,
    x2: 57.6759,
    y2: 47.9272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_33_43",
    x1: 29.594,
    y1: 39.5191,
    x2: 58.242,
    y2: 39.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.0754,
    height: 95,
    fill: "white",
    transform: "translate(0.635132)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsInfo);
export default __webpack_public_path__ + "static/media/detailsInfo.049338c07ed162816edcb5c5994c20dc.svg";
export { ForwardRef as ReactComponent };